import { Grid } from '@mui/material';
import './CustomToolbar.scss';
import { usePairingList } from '../../../providers/PairingListProvider';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DbmMbgLinks from '../../DbmMbgLinks/DbmMbgLinks';
import EditTableColumn from '../../EditTableColumn/EditTableColumn';
import { useState, useEffect, useRef } from 'react';
import { useGeneralPairing } from '../../../providers/GeneralPairing';
import { dates, months } from "../../../constants/dates";
import { CSVLink } from "react-csv";
import { getFormattedAllData } from "../../../helpers/getFormattedDataForExport";
import { useNotifications } from '../../../providers/Notifications';

export default function CustomToolbar({
    dbmInfo,
    setShowAddInput,
    showAddInput,
    xGridColumns,
    colVisibility,
    setColVisibility,
    presetDropdownOptions,
    totalNum,
    searchState,
    dataList,
    setLoading
}) {
    const pairingListContext = usePairingList();
    const generalPairingContext = useGeneralPairing();
    const { t } = useTranslation();
    // not sure how we plan on using this 
    const [hasRemoved] = useState(false);
    const [exportAllGrid, setToggleExportAllGrid] = useState(false);
    const totalPairingDeleted = dataList?.map(b => b?.pairinglist.filter(pairing => pairing.isDeleted === true)).reduce((a, b) => (a + b?.length), 0);
    const totalPairingModified = dataList?.map(b => b?.pairinglist.filter(pairing => pairing.isModified === true)).reduce((a, b) => (a + b?.length), 0);
    const NotificationsContext = useNotifications();

    const headers = [
        { label: "Category Name", key: "categoryName" },
        { label: "Pairing ID", key: "pairingId" },
        { label: "Days", key: "days" },
        { label: "Credit", key: "credit" },
        { label: "Route", key: "route" },
        { label: "On Duty", key: "onduty" },
        { label: "Off Duty", key: "offduty" },
        { label: "Hrs/Day", key: "hoursPerDay" },
        { label: "Expenses", key: "expenses" },
        { label: "Dates", key: "dates" },
        { label: "TAFB", key: "tafb" },
        { label: "EFF", key: "eff" },
        { label: "Flt#", key: "fltNo" },
        { label: "Day Credit", key: "daycredit" },
        { label: "Night Credit", key: "nightcredit" },
        { label: "Oseas Credit", key: "overseasCredit" },
        { label: "DH Credit", key: "dhCredit" },
        { label: "Sectors", key: "sectors" },
        { label: "Occurs", key: "occurs" },
        { label: "Pair Type", key: "pairType" },
    ];

    let keys = Object.keys(colVisibility);
    const filtered = keys.filter((key) => colVisibility[key])
    filtered.unshift("categoryName");

    const onClickAdd = () => {
        setShowAddInput(!showAddInput);
    }

    const removeDeletedPairings = () => {
        let deletedPairingArray = dataList?.map(b => b?.pairinglist.filter(pairing => pairing.isDeleted === true));
        if (deletedPairingArray.length > 0) {
            deletedPairingArray?.map(b => b?.map((pairing) => {
                if (!pairing.pairingId || !pairing.categoryid || !pairing.categoryname) {
                    return null;
                }
                removeDeletedPairing(pairing.pairingId, pairing.categoryname, pairing.categoryid);
                updateNotificationViewed();
                return pairing;
            }));
        }
    }

    const removeDeletedPairing = async (pairingId, categoryname, categoryid) => {
        if (!categoryname || !categoryid || !pairingId) {
            return;
        }
        await generalPairingContext.removePairing(categoryname, categoryid, searchState, pairingId);
        pairingListContext.getPairingListData(searchState);
    }

    const updateNotificationViewed = () => {
        const notifications = NotificationsContext.notifications?.result?.filter(notification => notification.module === "pairing.deleted");
        if(notifications?.length) {
                notifications.forEach(notification => {
                const year = notification.year;
                const month = notification.month;
                NotificationsContext.updateNotificationViewed(year, month, "pairing.deleted", notification.notificationId);
            });
        }
    }

    const hideChangedPairings = () => {
        let changedPairingArray = dataList?.map(b => b?.pairinglist.filter(pairing => pairing.isModified === true));
        if (changedPairingArray.length > 0) {
            changedPairingArray?.map(b => b?.map((pairing) => {
                if (!pairing.pairingId || !pairing.categoryid || !pairing.categoryname) {
                    return null;
                }
                hideChangedPairing(searchState);
                return pairing;
            }));
        }
    }

    const hideChangedPairing = async (searchState) => {
        if (!searchState) {
            return;
        }
        await generalPairingContext.hideChangedPairing(searchState);
        pairingListContext.getPairingListData(searchState);
    }

    const DownloadExcel = (props) => {
        const exportBtnRef = useRef<HTMLDivElement>(null);
        useEffect(() => {
            exportBtnRef.current?.click();
            setToggleExportAllGrid(false);
        }, [exportBtnRef]);
        return (
            <CSVLink {...props}>
                <span ref={exportBtnRef} />
            </CSVLink>
        )
    }

    return (
        <div className='toolbar-container'>
            <Grid container>
                <DbmMbgLinks dbmInfo={dbmInfo} searchState={searchState} />
                <Grid item sm />
                <Grid item className='right-block'>
                    <button className='add-category-btn' onClick={() => onClickAdd()}>
                        <AddCircleOutlineIcon className="add-category-icon link-states" />&nbsp;
                        {t('pairingList.addCategory')}
                    </button>
                    {exportAllGrid &&
                        <DownloadExcel data={getFormattedAllData(dataList)} headers={headers.filter(item => filtered.includes(item.key))} filename={"my-ACcess.csv"} />
                    }
                    <button className='export-btn link-states' onClick={() => setToggleExportAllGrid(true)}>
                        <i className="icon-Export-Icon"></i>&nbsp;
                        {t('pairingList.export')}
                    </button>
                    <EditTableColumn
                        presetDropdownOptions={presetDropdownOptions}
                        xGridColumns={xGridColumns}
                        colVisibility={colVisibility}
                        setColVisibility={setColVisibility}
                        setLoading={setLoading}
                    />
                    <Grid item xs={12} />
                    <Link to={{ 
                        pathname: '/pairing-package',
                        state: { pairingListSearchState: searchState }
                        }} 
                        className='pairing-package-link disableRipple disableElevation'>
                        {t('pairingList.pairingPackage')} {months[dates.indexOf(searchState.selectedDate.split(' ')[0])]} <span className='icon-list link-states'></span>
                    </Link>
                </Grid>

            </Grid>
            {hasRemoved ?
                (<div className='removed-info'>
                    <span className="left-bord" /><HighlightOffIcon />
                    <div className="remove-box">{t('pairingList.noPairingInfo')}
                        <span className='remove-link'>
                            {t('pairingList.removePairing')}
                        </span>
                    </div>
                </div>) : ""}
            {totalPairingDeleted > 0 ?
                <div className='pairing-list-div-deleted'>
                    <i className='icon-Error-warning' />
                    <div>{totalPairingDeleted} {t('pairingList.pairingDeleted')}
                        <span className="pairing-list-remove-pairings" onClick={() => { removeDeletedPairings(); }}>
                            Remove pairings.
                        </span>
                    </div>
                </div> : ""}
            {totalPairingModified > 0 ?
                <div className='pairing-list-div-modified'>
                    <i className='icon-circle-flight .pairing-list-modified-icon' />
                    <div>{totalPairingModified} {t('pairingList.pairingModified')}
                        <span className="pairing-list-changed-pairings" onClick={() => { hideChangedPairings(); }}>
                            {t('pairingList.acknowledgeChangedAlert')}
                        </span>
                    </div>
                </div> : ""}
            {!!totalNum && <div className='multisort-instruction'>{t('dbm.multiSortInstruction')}</div>}
        </div>
    );
}
